export function clientInvoices(invoices, client) {
  if (!client) return invoices;
  return invoices.filter(invoice => {
    const id = invoice.client?._id || invoice.clientId || (typeof invoice.client === "string" ? invoice.client : null);
    if (id) return String(id) === String(client._id);
    if (invoice.IdClient != null && client.pld != null && String(client.pld).trim()) return String(invoice.IdClient) === String(client.pld);
    const name = String(client.companyName || client.denomination || "").trim().toLocaleLowerCase("fr-FR");
    return Boolean(name) && String(invoice.RaisonSociale || invoice.client?.companyName || "").trim().toLocaleLowerCase("fr-FR") === name;
  });
}
